import { isObj } from './object';

export function flattenObject<T extends object>(obj: T): any {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (isObj(value) && value !== null) {
      return {
        ...acc,
        ...flattenObject(value),
      };
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});
}
